import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-error-404-page',
  templateUrl: './error-404-page.component.html',
  styleUrls: [
    './styles/error-404-page.styles.scss',
    './styles/error-404-page.theme.scss'
  ],
  encapsulation: ViewEncapsulation.None
})
export class Error404PageComponent {


}



// WEBPACK FOOTER //
// ./src/app/system/core/404/error-404-page.component.ts